import { Link, useLocation } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { useAuth } from "../../providers/AuthProvider";

export default function Home() {
	const { isAuth } = useAuth();
	const location = useLocation();
	const isTicketOffice = location.pathname.includes("ticket-office");

	useDocumentTitle("Πιστοποίηση στοιχείων για είσοδο σε αγώνα");

	const redirectPath = (type) => {
		if (type === "confirmation") {
			return isTicketOffice ? "/ticket-office/confirmation" : "/tickets/confirmation";
		} else {
			return isTicketOffice ? "/ticket-office/login-app" : "/tickets/login-app";
		}
	};

	const actionPath = isAuth ? redirectPath("confirmation") : redirectPath("login");

	return (
		<MainContainer>
			<div className="col-lg-8">
				<h1 className="mb-4">Πιστοποίηση στοιχείων για είσοδο σε αγώνα</h1>
				<p>
					Με το εισιτήριο στο Gov.gr Wallet πάμε στους αγώνες των αγαπημένων μας ομάδων. Η πλατφόρμα χρησιμοποιείται για τις
					περιπτώσεις συνοδείας ανηλίκων:
				</p>
				<ul style={{ padding: "20px 0 0 35px" }}>
					<li>Αποστολή και ακύρωση αιτήματος συνοδείας σε τρίτο</li>
					<li>Μεταβίβαση συνοδείας</li>
					<li>Ανάκληση συνοδείας</li>
				</ul>
				<p>
					Για περισσότερες πληροφορίες και οδηγίες επισκεφθείτε το <a href="https://tickets.gov.gr/">tickets.gov.gr</a>
				</p>
				<p>Θα χρειαστείτε τους προσωπικούς σας κωδικούς πρόσβασης στο Taxisnet.</p>
				<Link to={actionPath} className="btn-blue btn btn-primary btn-lg mt-4">
					<span>Είσοδος στην υπηρεσία</span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						height="1em"
						viewBox="0 0 512 512"
						fill="#ffffff"
						aria-hidden="true"
						focusable="false"
					>
						<path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"></path>
					</svg>
				</Link>
				<div style={{ fontSize: "12px" }}>
					Η πλατφόρμα χρησιμοποιείται από τις ομάδες (ΠΑΕ/ΚΑΕ) για την αντιμετώπιση των περιπτώσεων αδυναμίας ταυτοποίησης μέσω
					του Gov.gr Wallet
				</div>
			</div>
		</MainContainer>
	);
}
